import { Component, OnInit } from '@angular/core'
import moment from 'moment'
import { lastValueFrom } from 'rxjs'
import { NafcoActuateSetting, UpdateLabelOption, UpdatMenuSwitchingDate } from 'src/api/nafco-frimo-api/nafco-frimo-api.interface'
import { NafcoFrimoApiService } from 'src/api/nafco-frimo-api/nafco-frimo-api.service'
import { messageList } from 'src/app/components/message/message-data'
import { MessageService } from 'src/app/components/message/message.service'
import { ActionTargetInfo, GridActionButton } from 'src/app/module/is-grid/action-grid/action-grid.component.interface'
import { Header, RowSelection } from 'src/app/module/is-grid/base-grid/base-grid.component.interface'
export enum ActionCd {
  SETTING_MENU = 'settingMenuDate',
  SETTING_OPTION = 'settingOption'
}
@Component({
  selector: 'app-ura-nafco-actuate-setting',
  templateUrl: './ura-nafco-actuate-setting.component.html',
  styleUrls: ['./ura-nafco-actuate-setting.component.scss']
})
export class UraNafcoActuateSettingComponent implements OnInit {
  title = 'ナフコ専用 サービス稼働設定'
  data: NafcoActuateSetting[] = []
  columns: Header[] = [
    {
      key: 'productActuateCd',
      label: 'productActuateCd',
      hidden: true
    },
    {
      key: 'contractCompanyOrganizationName',
      label: '契約会社',
      sort: true
    },
    {
      key: 'productMerchandiseName',
      label: 'プロダクト',
      sort: true
    },
    {
      key: 'status',
      label: 'ステータス',
      hidden: true
    },
    {
      key: 'statusUi',
      label: 'ステータス',
      sort: true
    },
    {
      key: 'productInquiryCd',
      label: 'プロダクトコード',
      sort: true,
    },
    {
      key: 'supplierCd',
      label: '仕入先コード',
      sort: true,
    },
    {
      key: 'suppliContractDetailId',
      label: 'SuppliサービスID',
      sort: true,
    },
    {
      key: 'suppliInquiryNo',
      label: '旧お問い合わせNo.',
      sort: true,
    },
    {
      key: 'frimoCd',
      label: 'FRIMOコード',
      sort: true,
    },
    {
      key: 'shipPlaceName',
      label: '出荷場所名',
      sort: true,
    },
    {
      key: 'labelMerchandiseName',
      label: 'オプション',
      sort: true,
      groupLabel: 'Ura-idea'
    },
    {
      key: 'labelActuateStartDatetimeUi',
      label: 'OP利用開始日',
      sort: true,
      groupLabel: 'Ura-idea'
    },
    {
      key: 'registedLabelMerchandiseName',
      label: 'オプション',
      sort: true,
      groupLabel: 'ナフコFRIMO'
    },
    {
      key: 'menuSwitchingDatetimeUi',
      label: '新メニュー開始日',
      sort: true,
      groupLabel: 'ナフコFRIMO'
    },
    {
      key: 'labelStartDatetimeUi',
      label: 'OP利用開始日',
      sort: true,
      groupLabel: 'ナフコFRIMO'
    },
    {
      key: 'packageNumberStartDatetimeUi',
      label: '荷物番号取込オプション利用開始日',
      sort: true,
      groupLabel: 'ナフコFRIMO'
    },
  ]
  rowSelection = RowSelection.MULTIPLE
  actionButtons: GridActionButton[] = [
    {
      label: '新メニュー開始日設定',
      actionCd: ActionCd.SETTING_MENU,
    },
    {
      label: 'OP情報を登録',
      actionCd: ActionCd.SETTING_OPTION,
      confirmDialog: true
    }
  ]
  loading = true
  sending = false
  showDialog = false
  selectRows: NafcoActuateSetting[] = []
  dialogMessage = ''
  inputDate: Date
  cellClasses = {
    color_red: (rowData: any, columnKey: string): boolean => {
      return columnKey === 'statusUi' && (rowData.status === '0' || rowData.status === '1')
    },
  }

  constructor(
    private nafcoFrimoApiService: NafcoFrimoApiService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.getContractCompanyList()
  }

  async getContractCompanyList(): Promise<void> {
    this.data = []
    this.loading = true
    // const ret = await this.nafcoFrimoApiService.GetNafcoActuateSettings().toPromise()
    const ret$ = this.nafcoFrimoApiService.GetNafcoActuateSettings()
    let ret = await lastValueFrom(ret$)

    this.loading = false
    if (ret?.resultCode !== 0) { return }
    this.data = ret.data
    this.data.forEach(item => {
      item.labelMerchandiseName = (item.labelMerchandiseName ?? '').replace('個口納品書＋PDラベル ', '')
      if ((item.status === '1' || item.status === '2')) {
        item.actionCds = [ ActionCd.SETTING_MENU ]
        if (item.labelProductCd !== item.registedLabelProductCd) {
          item.actionCds.push(ActionCd.SETTING_OPTION)
        }
      }
    })
  }

  actionCommit(event: ActionTargetInfo): void {
    const action = this.actionButtons.find(x => x.actionCd === event.actionCd)
    if (action.actionCd === ActionCd.SETTING_MENU) {
      this.showDialog = true
      this.dialogMessage = '新メニュー開始日を設定します'
      this.selectRows = event.rows
      return
    }
    else if (action.actionCd === ActionCd.SETTING_OPTION) {
      this.selectRows = event.rows
      this.updateLabelOption()
      return
    }
  }

  daialogCommit(): void {
    if (!this.inputDate) {
      this.messageService.templeteMessage(messageList.M00022)
      return
    }
    this.updateMenuDate()
    this.showDialog = false
  }

  async updateMenuDate(): Promise<void> {
    const payload: UpdatMenuSwitchingDate[] = []
    this.selectRows.forEach(row => {
      const rowData: UpdatMenuSwitchingDate = {
        productActuateCd: row.productActuateCd,
        menuSwitchingDatetime: moment(this.inputDate).format('YYYY-MM-DD') + 'T00:00:00.000'
      }
      payload.push(rowData)
    })
    if (this.sending) { return }
    this.sending = true
    // const ret = await this.nafcoFrimoApiService.UpdateMenuDate(payload).toPromise()
    const ret$ = this.nafcoFrimoApiService.UpdateMenuDate(payload)
    let ret = await lastValueFrom(ret$)

    this.sending = false
    if (ret?.resultCode !== 0) { return }
    this.messageService.templeteMessage(messageList.M00054)
    this.getContractCompanyList()
  }

  async updateLabelOption(): Promise<void> {
    const payload: UpdateLabelOption[] = []
    this.selectRows.forEach(row => {
      const rowData: UpdateLabelOption = {
        productActuateCd: row.productActuateCd,
        labelStartDatetime: null // nullにすると稼働開始日が反映される
      }
      payload.push(rowData)
    })
    if (this.sending) { return }
    this.sending = true
    // const ret = await this.nafcoFrimoApiService.UpdateLabelOption(payload).toPromise()
    const ret$ = this.nafcoFrimoApiService.UpdateLabelOption(payload)
    let ret = await lastValueFrom(ret$)

    this.sending = false
    if (ret?.resultCode !== 0) { return }
    this.messageService.templeteMessage(messageList.M00056)
    this.getContractCompanyList()
  }
}
